import { render, staticRenderFns } from "./CustomerTabUsers.vue?vue&type=template&id=637aa683&scoped=true"
import script from "./CustomerTabUsers.vue?vue&type=script&lang=ts"
export * from "./CustomerTabUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637aa683",
  null
  
)

export default component.exports